import {
	ASSIGNMENT_STATUSES,
	GROUP_RECONCILIATION_STATUSES,
} from 'pages/RideDetails/components/Assigment/const';

export const getActivityActions = (assignment, callbacks = {}) => {
	if (!assignment) return [];

	const isPending = assignment.reconciliationStatus === ASSIGNMENT_STATUSES.PENDING;
	const isEditable = assignment.isEditable !== false;
	const isReconciled =
		assignment.reconciliationStatus === GROUP_RECONCILIATION_STATUSES.AUTO ||
		assignment.reconciliationStatus === GROUP_RECONCILIATION_STATUSES.MANUAL;

	return [
		{
			id: 'manual-reconciliation',
			label: 'Manual reconciliation',
			disabled: isPending,
			action: () =>
				callbacks.onManualReconciliation?.({
					assignmentId: assignment.id,
					reconciliationStatus: assignment.reconciliationStatus,
				}),
		},
		{ id: 'divider-reconciliation', divider: true },
		{
			id: 'assign-driver',
			label: 'Assign driver',
			disabled: !isPending || !isEditable,
			action: () =>
				callbacks.onAssignDriver?.({
					assignmentId: assignment.id,
					job: assignment.job ?? null,
					run: assignment.run ?? null,
					runName: assignment.run?.name ?? null,
					plannedArrival: assignment.plannedArrival ?? null,
					originalCrewMemberId: assignment.crewMember?.id ?? null,
				}),
		},
		{
			id: 'assign-job-return',
			label: 'Assign job + return',
			disabled: !isPending || !isEditable,
			action: () =>
				callbacks.onAssignJobReturn?.({
					assignmentId: assignment?.id,
					job: assignment.job ?? null,
					run: assignment.run ?? null,
					runName: assignment.run?.name ?? null,
					plannedArrival: assignment.plannedArrival ?? null,
					originalCrewMemberId: assignment.crewMember?.id ?? null,
				}),
		},
		{ id: 'divider-assign-job-return', divider: true },
		{
			id: 'show-related-assignments',
			label: 'Show related assignments',
			disabled: !assignment.run && !assignment.job,
			action: () =>
				callbacks.onShowRelatedAssignments?.({
					runName: assignment.run?.name ?? null,
					ridePlannedDeparture: assignment.ridePlannedDeparture ?? null,
					jobCode: assignment.job?.code ?? null,
					sequenceGroupId: assignment.sequenceGroupId ?? null,
				}),
		},
		{
			id: 'split-assignment',
			label: 'Split assignment',
			disabled: !isEditable || isReconciled || assignment.status === ASSIGNMENT_STATUSES.REJECTED,
			action: () =>
				callbacks.onSplitAssignment?.({
					assignmentId: assignment.id,
				}),
		},
	];
};
